// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LinkedIn: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 36 36">
            <g fill="none" fillRule="evenodd">
                <circle cx="18" cy="18" r="17.5" stroke="currentColor" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M13.58 26h-3.316V15.32h3.317V26zm-1.66-12.137c-1.06 0-1.92-.879-1.92-1.94a1.92 1.92 0 1 1 3.841.001c0 1.06-.86 1.939-1.92 1.939zM25.995 26h-3.31v-5.2c0-1.238-.025-2.827-1.724-2.827-1.724 0-1.989 1.346-1.989 2.739V26h-3.313V15.32h3.181v1.456h.047c.443-.839 1.524-1.724 3.138-1.724 3.356 0 3.973 2.21 3.973 5.081V26h-.003z"
                />
            </g>
        </svg>
    );
};

export default React.memo(LinkedIn);
